module.exports = __webpack_public_path__ + "static/media/netflix.f883e90c.svg";